export enum DashboardDataGridField {
  Star = "star",
  Market = "title",
  Category = "category",
  PercentageChance = "percentageChance",
  Spread = "spread",
  Volume = "volume",
  Liquidity = "liquidity",
  H24 = "volume24pers",
  D7 = "volume7pers",
  MarketCount = "marketCount",
  EndsIn = "endDate",
  Platforms = "platforms",
}
